import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="min-h-screen flex items-center py-20 px-4 md:px-10 bg-white">
      <div className="max-w-[90rem] mx-auto grid grid-cols-1 gap-12 lg:gap-20">
        <div className="w-full">
          <h1 
            className="font-display text-6xl md:text-8xl lg:text-[10rem] font-bold leading-[1.1] md:leading-[0.85] uppercase tracking-tighter animate-gradient-text"
            dangerouslySetInnerHTML={{ __html: t('hero.title') }}
          />
        </div>
        <div className="max-w-4xl ml-auto w-full">
          <p className="font-sans text-2xl md:text-4xl text-gray-500 leading-tight font-light">
            {t('hero.description')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
